import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customers/:customerId/sales-invoices/full-settlement`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const fullSettlement = {
  post: apiPathFunc(pathBase),
};
